import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-CzechRepublic",
  "use": "icon-CzechRepublic-usage",
  "viewBox": "0 0 1365 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1365 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-CzechRepublic\"><path d=\"M0 0v1024h1365.333333V0H0z\" fill=\"#E31D1C\" p-id=\"16295\" /><path d=\"M1365.333333 0H0v512h1365.333333V0z\" fill=\"#F7FCFF\" p-id=\"16296\" /><path d=\"M0 0v1024l768-512L0 0z\" fill=\"#3D58DB\" p-id=\"16297\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol